import { render, staticRenderFns } from "./AssignDriverModal.vue?vue&type=template&id=22a30f04"
import script from "./AssignDriverModal.vue?vue&type=script&lang=ts"
export * from "./AssignDriverModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports